import { RoleEnum, useMigrateToV2Mutation } from '@/types/generated/graphql';
import { AppModal } from '@components/form/Modal';
import { AppInput } from '@components/form/input/app-input';
import { zodResolver } from '@hookform/resolvers/zod';
import { useUserRole } from '@shared/hooks/use-user-role';
import { capitalize } from '@shared/utils/capitalize';
import { Button, notification } from 'antd';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';
import z from 'zod';
import { useStoreMigrateModal } from './channel-migrate.store';
const confirmation_text = 'Permanent Switch';

function ChannelMigrateModal() {
  const user = useUserRole();
  const isOwner = user?.role === RoleEnum.owner;

  const { t } = useTranslation();
  const { open, closeModal } = useStoreMigrateModal();

  const { control, handleSubmit, reset, clearErrors } = useForm({
    defaultValues: {
      confirmation: '',
    },
    resolver: zodResolver(
      z.object({
        confirmation: z
          .string({ message: t('invalid_confirmation') })
          .regex(new RegExp(`^${confirmation_text}$`), `Please type ${confirmation_text} to confirm`),
      })
    ),
  });

  const [permanentMigrate, { loading }] = useMigrateToV2Mutation({
    onCompleted: ({ migrateToV2 }) => {
      notification.success({ message: migrateToV2?.message, duration: 5000 });
      closeModal();
    },
    onError: ({ message }) => {
      notification.error({ message });
    },
  });

  useEffect(
    function resetFormOnClose() {
      reset();
      clearErrors();
    },
    [open]
  );

  return (
    <AppModal
      styles={{
        wrapper: {
          zIndex: 100000,
        },
      }}
      open={open}
      onCancel={closeModal}
      centered
      title={
        <AppModal.Header>
          <AppModal.Title>{t('permanently_switch_to_new_experience')}</AppModal.Title>
          <AppModal.SubTitle>
            <p>
              <Trans
                i18nKey="once_migrated_you_cannot_switch_back_to_old_experience"
                components={[<b key="warning-bold" className="text-red-400"></b>]}
              />
            </p>
          </AppModal.SubTitle>
        </AppModal.Header>
      }
      footer={
        isOwner ? (
          <AppModal.Footer className="flex">
            <Button variant="outlined" className="w-full capitalize!" onClick={() => closeModal()} loading={false}>
              {t('not_now')}
            </Button>
            <AppModal.Button
              loading={loading}
              className="w-full capitalize!"
              onClick={handleSubmit(() => permanentMigrate())}
              type="primary"
            >
              {t('switch')}
            </AppModal.Button>
          </AppModal.Footer>
        ) : null
      }
    >
      {isOwner ? (
        <AppModal.Body className="space-y-4">
          <p>{t('the_new_experience_is_loaded_with_powerful_features_smoother_workflows')}</p>
          <section>
            <strong>{t('to_confirm_type_text_in_the_box_below', { text: confirmation_text })}</strong>
            <AppInput control={control} name="confirmation" placeholder={capitalize(t('enter_here'))} />
          </section>
        </AppModal.Body>
      ) : (
        <AppModal.Body className="space-y-4">
          <p>
            {t('you_are_not_authorized_to_perform_this_action')} <br /> {t('please_contact_your_administrator')}
          </p>
        </AppModal.Body>
      )}
    </AppModal>
  );
}

export default ChannelMigrateModal;
